export default "__VITE_ASSET__B$nU3jZ5__"